"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useStorage(key, initialValue, persist) {
    if (persist === void 0) { persist = false; }
    var _a = (0, react_1.useState)(initialValue), storedValue = _a[0], setStoredValue = _a[1];
    var storage = persist ? "localStorage" : "sessionStorage";
    var readValue = function () {
        if (typeof window === "undefined") {
            return initialValue;
        }
        var item = window[storage].getItem(key);
        try {
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            return (item !== null && item !== void 0 ? item : initialValue);
        }
    };
    var setValue = function (value) {
        try {
            var newValue = value instanceof Function ? value(storedValue) : value;
            if (typeof newValue !== "undefined") {
                window[storage].setItem(key, typeof newValue === "object" ? JSON.stringify(newValue) : String(newValue));
            }
            else {
                window[storage].removeItem(key);
            }
            setStoredValue(newValue);
            window.dispatchEvent(new Event("local-storage"));
        }
        catch (error) { }
    };
    (0, react_1.useEffect)(function () {
        var value = readValue();
        if (typeof value !== "undefined") {
            setValue(value);
            setStoredValue(value);
        }
    }, []);
    (0, react_1.useEffect)(function () {
        var handleStorageChange = function () {
            setStoredValue(readValue());
        };
        window.addEventListener("storage", handleStorageChange);
        window.addEventListener("local-storage", handleStorageChange);
        return function () {
            window.removeEventListener("storage", handleStorageChange);
            window.removeEventListener("local-storage", handleStorageChange);
        };
    }, []);
    return [storedValue, setValue];
}
exports.default = useStorage;
//# sourceMappingURL=index.js.map